import { render, staticRenderFns } from "./MasterplanStreetsWidgetDialog.vue?vue&type=template&id=31a254d4&scoped=true&"
import script from "./MasterplanStreetsWidgetDialog.vue?vue&type=script&lang=js&"
export * from "./MasterplanStreetsWidgetDialog.vue?vue&type=script&lang=js&"
import style0 from "./MasterplanStreetsWidgetDialog.vue?vue&type=style&index=0&id=31a254d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a254d4",
  null
  
)

export default component.exports